import { render, staticRenderFns } from "./eventReport.vue?vue&type=template&id=23ebcfe8&scoped=true&"
import script from "./eventReport.vue?vue&type=script&lang=js&"
export * from "./eventReport.vue?vue&type=script&lang=js&"
import style0 from "./eventReport.vue?vue&type=style&index=0&id=23ebcfe8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ebcfe8",
  null
  
)

export default component.exports